import { createCultureI18n } from "@/shared/culture/i18n";

export const { i18n: appI18n, initialization: appI18nInitialization } = createCultureI18n();
